"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./Text.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Text = function Text(_ref) {
  var asset = _ref.asset,
      sizeOfElements = _ref.sizeOfElements;
  return /*#__PURE__*/_react.default.createElement("label", {
    className: "text-container",
    style: {
      maxWidth: "".concat(sizeOfElements.width * 3, "px"),
      left: asset.left,
      top: asset.top
    }
  }, asset.labelValue ? /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: asset.labelValue.replace(/\n/g, '</br>\n')
    }
  }) : 'label');
};

var _default = Text;
exports.default = _default;